import { RequestAccessModalApp } from './../Functionality/RequestAccessModalApp';
import CustomModal from './../../../../../components/Modal/CustomModal';
import React from "react";
import RequestAccessForm from "./RequestAccessForm";
import {CustomAddChip} from "../../../../../components/CustomAddChip";
import {filterByLabelEmailPhone, userListToLabelEmailPhoneValue} from "../../../../../Apis/functions";
import {PersonChipBlack} from "../../../../../components/buttons/IconButtons";
/**
 * @Author: Susana García Rodríguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 */
const RequestAccessModal = (props) => {
    const { title, onHide, setModified, selectedList } = props;

    const {
        t,
        disable,
        emptyFields,
        handleCreate,
        handleClear,
        photoPickerFile,
        setPhotoPickerFile,
        allEmployees,
        selectedHost,
        setSelectedHost,
        requestAccessItem,
        handleChange,
        displayModal, setDisplayModal
    } = RequestAccessModalApp({ setModified, onHide, selectedList });

    return (
        <>
            <CustomModal
                {...props}
                display={displayModal}
                size='md'
                aria-labelledby='contained-modal-title-vcenter'
                centered
                className='add_zone_modal'
                onConfirm={handleCreate}
                title={title}
                onHide={handleClear}
            >
                <div className='row'>
                    <div className='col-sm-12 col-xxl-12 col-lg-12'>
                        <CustomAddChip
                            autocompleteId={'slt_ram_host'}
                            buttonId={'btn_ram_host'}
                            label={t("host_person_to_visit")}
                            required={true}
                            data={userListToLabelEmailPhoneValue(allEmployees, 'userId', true, PersonChipBlack)}
                            selectedList={selectedHost}
                            setSelectedList={setSelectedHost}
                            noDisabledChip={true}
                            showRenderOption={true}
                            filterOptions={filterByLabelEmailPhone}
                            maxLength={1}
                            hideButton={true}
                            emptyFields={emptyFields && selectedHost?.length === 0}
                            reset={false}
                            chipIcon={PersonChipBlack}
                        />
                    </div>

                    <RequestAccessForm
                        t={t}
                        emptyFields={emptyFields}
                        requestAccessItem={requestAccessItem}
                        disabled={disable}
                        photoPickerFile={photoPickerFile}
                        setPhotoPickerFile={setPhotoPickerFile}
                        handleChange={handleChange}
                        setDisplayModal={setDisplayModal}
                    />
                </div>
            </CustomModal>
        </>
    );
};

export default RequestAccessModal;
